import type { TheoryTest, TheoryTestSubmission, TheoryTestTemplate } from "./TheoryTest.typed";
import type { TheoryTestModel } from "./TheoryTestModel";

export class TheoryTestAdapter {
  private theoryTestModel: TheoryTestModel;

  constructor(theoryTestModel: TheoryTestModel) {
    this.theoryTestModel = theoryTestModel;
  }

  async getPublicTheoryTestTemplate(
    trainingTemplateId: string,
    token: string,
  ): Promise<TheoryTestTemplate | null> {
    return this.theoryTestModel.getPublicTheoryTestTemplate(trainingTemplateId, token);
  }

  async submitTheoryTest(
    trainingTemplateId: string,
    userId: string,
    data: TheoryTestSubmission,
    token: string,
  ): Promise<TheoryTest> {
    return this.theoryTestModel.submitTheoryTest(trainingTemplateId, userId, data, token);
  }
}
